(function () {
  'use strict';

  var ACCENTS = ['#f2a93b', '#ea5e2c', '#c73e6b', '#33456e', '#1b2c40'];

  function init() {
    var content = document.querySelector('.blog-layout__content');
    if (!content) return;
    try { transformTables(content); } catch (e) {}
    try { transformSteps(content); } catch (e) {}
    try { transformNumberedParas(content); } catch (e) {}
    try { transformFaq(content); } catch (e) {}
    try { injectReadingTime(content); } catch (e) {}
  }

  /* 3-column tables -> phase cards with gradient bar */
  function transformTables(content) {
    content.querySelectorAll('table').forEach(function (table) {
      var rows = Array.prototype.slice.call(table.querySelectorAll('tr'));
      if (rows.length < 3 || rows.length > 7) return;
      if (rows[0].children.length !== 3) return;
      var body = rows.slice(1);
      var ok = body.every(function (tr) { return tr.children.length === 3; });
      if (!ok) return;

      var wrap = document.createElement('div');
      wrap.className = 'rd-phase-wrap';
      var bar = document.createElement('div');
      bar.className = 'rd-phase-bar';
      wrap.appendChild(bar);
      var grid = document.createElement('div');
      grid.className = 'rd-phase-grid';

      body.forEach(function (tr, i) {
        var c = tr.children;
        var accent = ACCENTS[i % ACCENTS.length];
        var card = document.createElement('div');
        card.className = 'rd-phase';
        card.style.borderTopColor = accent;
        var h = document.createElement('h3');
        h.innerHTML = c[0].innerHTML;
        var t = document.createElement('div');
        t.className = 'rd-phase-time';
        t.style.color = accent;
        t.innerHTML = c[1].innerHTML;
        var p = document.createElement('p');
        p.innerHTML = c[2].innerHTML;
        card.appendChild(h);
        card.appendChild(t);
        card.appendChild(p);
        grid.appendChild(card);
      });

      wrap.appendChild(grid);
      table.replaceWith(wrap);
    });
  }

  function buildStepCard(num, title, html) {
    var card = document.createElement('div');
    card.className = 'rd-step';
    var n = document.createElement('div');
    n.className = 'rd-step-num';
    n.textContent = String(num);
    var h = document.createElement('h3');
    h.textContent = title;
    var p = document.createElement('p');
    p.innerHTML = html;
    card.appendChild(n);
    card.appendChild(h);
    card.appendChild(p);
    return card;
  }

  /* ordered lists of 2-4 items that each start bold -> numbered cards */
  function transformSteps(content) {
    content.querySelectorAll('ol').forEach(function (ol) {
      var items = Array.prototype.filter.call(ol.children, function (n) { return n.tagName === 'LI'; });
      if (items.length < 2 || items.length > 4) return;
      var allBold = items.every(function (li) {
        var s = li.querySelector('strong,b');
        return s && li.textContent.trim().indexOf(s.textContent.trim()) === 0 && s.textContent.trim().length > 2;
      });
      if (!allBold) return;

      var grid = document.createElement('div');
      grid.className = 'rd-steps';
      items.forEach(function (li, i) {
        var s = li.querySelector('strong,b');
        var title = s.textContent.replace(/^\s*\d+[.)]\s*/, '').replace(/[\s.:]+$/, '');
        s.remove();
        var html = li.innerHTML.replace(/^\s*(<br\s*\/?\s*>)*\s*/, '');
        grid.appendChild(buildStepCard(i + 1, title, html));
      });
      ol.replaceWith(grid);
    });
  }

  /* 2-4 consecutive paragraphs like "1. <strong>Title.</strong> text" -> numbered cards */
  function transformNumberedParas(content) {
    content.querySelectorAll('.blog-card').forEach(function (card) {
      var children = Array.prototype.slice.call(card.children);
      var groups = [];
      var current = [];
      children.forEach(function (n) {
        var isStep = n.tagName === 'P' && /^\s*\d+[.)]\s/.test(n.textContent) && n.querySelector('strong,b');
        if (isStep) {
          current.push(n);
        } else {
          if (current.length >= 2 && current.length <= 4) groups.push(current);
          current = [];
        }
      });
      if (current.length >= 2 && current.length <= 4) groups.push(current);

      groups.forEach(function (group) {
        var grid = document.createElement('div');
        grid.className = 'rd-steps';
        group[0].parentNode.insertBefore(grid, group[0]);
        group.forEach(function (p, i) {
          var s = p.querySelector('strong,b');
          var title = s.textContent.replace(/^\s*\d+[.)]\s*/, '').replace(/[\s.:]+$/, '');
          s.remove();
          var html = p.innerHTML
            .replace(/^\s*\d+[.)]\s*/, '')
            .replace(/^\s*(<br\s*\/?\s*>)*\s*/, '');
          grid.appendChild(buildStepCard(i + 1, title, html));
          p.remove();
        });
      });
    });
  }

  /* sections with 2+ bold questions ending in "?" -> accordion + FAQPage schema */
  function transformFaq(content) {
    function isQuestion(node) {
      if (!node || node.tagName !== 'P') return false;
      var s = node.querySelector('strong,b');
      if (!s) return false;
      var q = s.textContent.trim();
      return /\?$/.test(q) && node.textContent.trim().indexOf(q) === 0;
    }

    var faqPairs = [];

    content.querySelectorAll('.blog-card').forEach(function (card) {
      var paras = Array.prototype.slice.call(card.children).filter(function (n) { return n.tagName === 'P'; });
      var questions = paras.filter(isQuestion);
      if (questions.length < 2) return;

      questions.forEach(function (p, qi) {
        var s = p.querySelector('strong,b');
        var qText = s.textContent.trim();
        var details = document.createElement('details');
        details.className = 'rd-faq';
        if (qi === 0) details.open = true;
        var summary = document.createElement('summary');
        summary.textContent = qText;
        var body = document.createElement('div');
        body.className = 'rd-faq-body';

        s.remove();
        var rest = p.innerHTML.replace(/^\s*(<br\s*\/?\s*>)*\s*/, '');
        if (rest.replace(/<[^>]*>/g, '').trim() !== '') {
          var ap = document.createElement('p');
          ap.innerHTML = rest;
          body.appendChild(ap);
        }

        var next = p.nextElementSibling;
        while (next && !isQuestion(next) && (next.tagName === 'P' || next.tagName === 'UL')) {
          var grab = next;
          next = next.nextElementSibling;
          body.appendChild(grab);
        }

        details.appendChild(summary);
        details.appendChild(body);
        p.replaceWith(details);

        var answerText = (body.textContent || '').trim().replace(/\s+/g, ' ');
        if (qText && answerText) faqPairs.push({ q: qText, a: answerText });
      });
    });

    if (faqPairs.length >= 2 && !document.querySelector('script[data-rd-faq-schema]')) {
      var ld = {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        'mainEntity': faqPairs.map(function (pair) {
          return {
            '@type': 'Question',
            'name': pair.q,
            'acceptedAnswer': { '@type': 'Answer', 'text': pair.a }
          };
        })
      };
      var script = document.createElement('script');
      script.type = 'application/ld+json';
      script.setAttribute('data-rd-faq-schema', '');
      script.textContent = JSON.stringify(ld);
      document.head.appendChild(script);
    }
  }

  /* word count -> "x min read" next to the date in the article banner */
  function injectReadingTime(content) {
    if (document.querySelector('.rd-readtime')) return;
    var words = (content.textContent || '').trim().split(/\s+/).length;
    var mins = Math.max(1, Math.round(words / 200));
    var banner = document.querySelector('[id*="main-article-banner"]');
    var timeEl = banner ? banner.querySelector('time') : null;
    if (!timeEl) return;
    var span = document.createElement('span');
    span.className = 'rd-readtime';
    span.textContent = ' · ' + mins + ' min read';
    timeEl.insertAdjacentElement('afterend', span);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
